// @flow
import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit';
import type { BookingPayment } from '../types';

export const getBookingPayments = createAsyncThunk(
  'booking/getBookingPayments',
  async (bookingId, thunkApi) => {
    try {
      const response = await thunkApi.extra.bookings.getBookingPayments(
        bookingId
      );

      return response.data;
    } catch (e) {
      return thunkApi.rejectWithValue({
        message: e?.message || e,
        code: e?.error || 0
      });
    }
  }
);

const bookingPaymentsAdapter = createEntityAdapter<BookingPayment>();

export type State = {
  isLoading: boolean,
  hasLoaded: boolean
};

export const customInitialState: State = {
  isLoading: false,
  hasLoaded: false
};

export const initialState = bookingPaymentsAdapter.getInitialState(
  customInitialState
);

const bookingPaymentsSlice = createSlice({
  name: 'bookingPayments',
  initialState,
  reducers: {},
  extraReducers: {
    [getBookingPayments.pending]: (state: State): State =>
      bookingPaymentsAdapter.removeAll({
        ...state,
        isLoading: true,
        hasLoaded: false
      }),
    [getBookingPayments.fulfilled]: (
      state: State,
      action: PayloadAction
    ): State =>
      bookingPaymentsAdapter.setAll(
        {
          ...state,
          isLoading: false,
          hasLoaded: true
        },
        action.payload
      ),
    [getBookingPayments.rejected]: (state: State): State => ({
      ...state,
      isLoading: false,
      hasLoaded: true
    })
  }
});

export const {
  selectAll: selectBookingPaymentsAll,
  selectTotal: selectBookingPaymentsTotal
} = bookingPaymentsAdapter.getSelectors(
  state => state[bookingPaymentsSlice.name]
);

export const selectBookingPaymentsIsLoading = state =>
  state[bookingPaymentsSlice.name].isLoading ||
  state[bookingPaymentsSlice.name].hasLoaded === false;

export const selectBookingPaymentsHasNoResults = state =>
  state[bookingPaymentsSlice.name].hasLoaded === true &&
  selectBookingPaymentsTotal(state) === 0;

export default bookingPaymentsSlice;
